import { getApiBaseUrl } from './csrf';
import {
  applyServerProfileFromApi,
  clearServerProfile,
} from './serverProfileCache';

/**
 * Fetch GET /api/v2/auth/me (credentials: include) and overwrite the in-memory server profile cache.
 * Call on protected app entry so roles/scopes/resource_mappings are never read from localStorage.
 */
export async function refreshServerProfile(): Promise<boolean> {
  try {
    const base = getApiBaseUrl();
    const res = await fetch(`${base}/api/v2/auth/me`, {
      credentials: 'include',
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || (data.statusCode !== undefined && data.statusCode >= 400)) {
      clearServerProfile();
      return false;
    }
    const profile = data.body;
    if (!profile || profile.user_id == null) {
      clearServerProfile();
      return false;
    }
    applyServerProfileFromApi(profile as Record<string, unknown>);
    return true;
  } catch {
    clearServerProfile();
    return false;
  }
}

/** @deprecated Use refreshServerProfile */
export const bootstrapWebSession = refreshServerProfile;
